if($('.news-item').length){
    $('.news-item a.title').each(function(){
        $(this).closest('.news-item').find('.text').append('<span class="link"><a href="'+$(this).attr('href')+'">Přečíst celé</a></span>')
    })
}

if($('.in-kontakty').length){
   // $('footer#footer').before($('div[itemprop="about"] iframe').addClass('customIframe'))
}


if($('.ZipDelivery').length){
    var colorboxContent = '<form id="validateZip"><fieldset>'
    colorboxContent += '<div class="rowLine">'
    colorboxContent += '<input type="text" id="zip" placeholder="např. 701 00" title="Vložte vaše PSČ"></div>'
    colorboxContent += '<div class="rowLine"><input type="submit" value="Ověřit" class="btn btn-secondary"></div>'
    colorboxContent += '</fieldset></form>'
    $('.ZipDelivery').html(colorboxContent)
    $('form#validateZip').on('submit', function(e){
        e.preventDefault();
        $('.deliveryRow').remove()
        var userZip = $('#zip').val().replace(/\s/g, '');
        if (userZip.length === 5 && /^\d+$/.test(userZip)) {
            var csvData = JSON.parse(sessionStorage.getItem('csvDataDelivery'));
            if (csvData) {
                var found = csvData.find(function(row) {
                    return row.PSC === userZip; // Porovnání PSČ
                });
                if (found) {
                    $(this).after('<div class="deliveryRow green">'+found['NAZEV-DOPRAVY']+'</div>')
                   
                } else {
                    var zipPrefix = userZip.substring(0, 2);
                    if (ZIP.includes(zipPrefix)) {
                        // První dvě číslice PSČ jsou v poli ZIP
                        $(this).after('<div class="deliveryRow green">Do vaší oblasti doručujeme. Pro více informací nás neváhejte <a href="/kontakt/" target="_blank">kontaktovat</a>.</div>')
                    } else {
                        // PSČ není v našem rozsahu doručování
                        $(this).after('<div class="deliveryRow green">'+hlaskaNedorucujeme+'</div>')
                    }
                }
            } else {
                // Nejsou načtená žádná data
            }
        } else {
            // Neplatné PSČ
            $(this).after('<div class="deliveryRow alert">Zadejte PSČ ve správném formátu, například 755 01.</div>')
        }
    });
}
